import { request } from "./http";

export interface LatLon { lat: number; lon: number; }

/**
 * Géocode une adresse (commune + code postal) — appelé à la sauvegarde d'un site (SiteForm)
 * quand l'adresse a changé, pour enregistrer ses coordonnées dans coverProps. La carte des
 * sites lit ensuite ces coordonnées directement, sans appel serveur.
 */
export function geocodeAddress(commune: string, codePostal: string): Promise<LatLon> {
  const qs = `commune=${encodeURIComponent(commune)}&codePostal=${encodeURIComponent(codePostal)}`;
  return request<LatLon>(`/datameteo/geocode?${qs}`);
}
